// An offer note cannot carry contact details. The database refuses the save
// (trigger trg_offers_note_contact → OFFER_NOTE_CONTACT_DETAILS, via
// mask_contact_details — SECURITY_BACKLOG #17, owner decision 2026-09-30:
// blocked at save). The rule lives there, on every door; this file only turns
// the refusal into words the supplier can act on. There is deliberately no
// client-side regex: one predicate, one place.

export const OFFER_NOTE_CONTACT_CODE = 'OFFER_NOTE_CONTACT_DETAILS';

export const OFFER_NOTE_CONTACT_MESSAGE = {
  ar: 'الملاحظة فيها وسيلة تواصل (رقم، إيميل، رابط، أو معرّف واتساب أو وي تشات). احذفها وأرسل العرض مرة ثانية — التواصل مع التاجر يكون عبر مَعبر.',
  en: 'Your note contains contact details (a number, email, link, or a WhatsApp or WeChat ID). Remove them and send the offer again — all contact with the trader goes through Maabar.',
  zh: '备注中包含联系方式（电话、邮箱、链接，或 WhatsApp、微信账号）。请删除后重新提交报价——与采购商的所有沟通均通过 Maabar 进行。',
};

export function isOfferNoteContactError(error) {
  const raw = String(error?.message || error || '');
  return raw.includes(OFFER_NOTE_CONTACT_CODE);
}

export function offerNoteContactMessage(lang) {
  return OFFER_NOTE_CONTACT_MESSAGE[lang] || OFFER_NOTE_CONTACT_MESSAGE.en;
}
